/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeploymentEvaluationSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetDeploymentEvaluationSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetDeploymentEvaluationSecurity = {
  option1?: GetDeploymentEvaluationSecurityOption1 | undefined;
  option2?: GetDeploymentEvaluationSecurityOption2 | undefined;
};

export type GetDeploymentEvaluationRequest = {
  /**
   * The ID of the deployment to evaluate.
   */
  deploymentId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetDeploymentEvaluationSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetDeploymentEvaluationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetDeploymentEvaluationSecurityOption1$Outbound,
    GetDeploymentEvaluationSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getDeploymentEvaluationSecurityOption1ToJSON(
  getDeploymentEvaluationSecurityOption1:
    GetDeploymentEvaluationSecurityOption1,
): string {
  return JSON.stringify(
    GetDeploymentEvaluationSecurityOption1$outboundSchema.parse(
      getDeploymentEvaluationSecurityOption1,
    ),
  );
}

/** @internal */
export type GetDeploymentEvaluationSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetDeploymentEvaluationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetDeploymentEvaluationSecurityOption2$Outbound,
    GetDeploymentEvaluationSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getDeploymentEvaluationSecurityOption2ToJSON(
  getDeploymentEvaluationSecurityOption2:
    GetDeploymentEvaluationSecurityOption2,
): string {
  return JSON.stringify(
    GetDeploymentEvaluationSecurityOption2$outboundSchema.parse(
      getDeploymentEvaluationSecurityOption2,
    ),
  );
}

/** @internal */
export type GetDeploymentEvaluationSecurity$Outbound = {
  Option1?: GetDeploymentEvaluationSecurityOption1$Outbound | undefined;
  Option2?: GetDeploymentEvaluationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetDeploymentEvaluationSecurity$outboundSchema: z.ZodMiniType<
  GetDeploymentEvaluationSecurity$Outbound,
  GetDeploymentEvaluationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetDeploymentEvaluationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetDeploymentEvaluationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getDeploymentEvaluationSecurityToJSON(
  getDeploymentEvaluationSecurity: GetDeploymentEvaluationSecurity,
): string {
  return JSON.stringify(
    GetDeploymentEvaluationSecurity$outboundSchema.parse(
      getDeploymentEvaluationSecurity,
    ),
  );
}

/** @internal */
export type GetDeploymentEvaluationRequest$Outbound = {
  deployment_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetDeploymentEvaluationRequest$outboundSchema: z.ZodMiniType<
  GetDeploymentEvaluationRequest$Outbound,
  GetDeploymentEvaluationRequest
> = z.pipe(
  z.object({
    deploymentId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getDeploymentEvaluationRequestToJSON(
  getDeploymentEvaluationRequest: GetDeploymentEvaluationRequest,
): string {
  return JSON.stringify(
    GetDeploymentEvaluationRequest$outboundSchema.parse(
      getDeploymentEvaluationRequest,
    ),
  );
}
